<template>
  <div class="subpage subpage-articles">
    <navbar />
    <section class="hero main-hero">
      <div class="hero-body">
        <div class="container">
          <nuxt />
        </div>
      </div>
    </section>
    <hero-action />
    <section class="section">
      <div class="container">
        <terms loan-type="consumer" />
      </div>
    </section>
    <section class="section">
      <div class="container">
        <lazy-hydrate when-visible>
          <banks />
        </lazy-hydrate>
      </div>
    </section>
    <lazy-hydrate ssr-only>
      <footer-comp />
    </lazy-hydrate>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration'

export default {
  components: {
    LazyHydrate,
    banks: () => import( '~/components/layout/banks' ),
    footerComp: () => import( '~/components/layout/footer' ),
    heroAction: () => import( '~/components/layout/heroAction' ),
    navbar: () => import( '~/components/layout/navbar' ),
    terms: () => import( '~/components/layout/terms' )
  },
  head () {
    const result = {
      link: [
        { rel: 'canonical', href: 'https://www.rahalaitos.fi' + this.$route.path }
      ]
    }

    if ( ['www2.rahalaitos.fi', 'rahalaitos-v2.local'].includes( this.$domain ) ) {
      result.meta = [{ hid: 'robots', name: 'robots', content: 'noindex' }]
    }

    return result
  },
  mounted () {
    if ( window.location.hostname === 'www2.rahalaitos.fi' ) {
      const newUrl = 'https://www.rahalaitos.fi' + window.location.pathname + window.location.search + window.location.hash
      window.location.replace( newUrl )
    }
  }
}
</script>

<style lang="scss">
  .subpage.subpage-articles {

    .content>.subpage_floating+h1 {
      background: none !important;
      padding: 0 !important;
      color: #363636 !important;
    }

  }
</style>
